export default {
    //ChangeSubscriptionComponent
    info_promotional_coupon: '¿Tienes un cupón promocional? Haz click en "Activar" para usarlo. ',

    //CurrentSubscriptionComponent
    canceled_message: 'Su cuenta ha sido cancelada. Suscríbase a un plan para volver a activar su cuenta.',

    //StripeNumberComponent
    change_pay_method: 'Cambiar método de pago',

    //NavigationMyAccountComponent e InformationComponent
    subtitle: 'Gira o seu perfil, a faturação e a subscrição da sua academia.',
    sections: 'Secções da minha conta',
    profile_description: 'Dados pessoais, foto e palavra-passe',
    billing_details: 'Dados de faturação',
    billing_details_description: 'Dados fiscais e conta bancária',
    my_subscription: 'A minha subscrição',
    my_subscription_description: 'Plano atual e faturas',
    plans_description: 'Mude ou reative o seu plano',
    my_academies: 'As minhas academias',
    my_academies_description: 'Academias da sua conta',
    about: 'Sobre',
    about_description: 'Versão e novidades',
    about_title: 'Informação da aplicação',
    app_name: 'Aplicação',
    manufacturer: 'Fabricante',
    version: 'Versão',
    changelog: 'Novidades',
    current_version: 'Versão atual',
    show_less: 'Ver menos',
    show_full_history: 'Ver o histórico completo (mais {count})',
    thanks: 'Obrigado por confiar na BrainsPro. Continuamos a melhorar a plataforma e aqui pode consultar as novidades à medida que as publicamos.',
}
